import '../css/app.css';
import '@mdi/font/css/materialdesignicons.min.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js';

require('./bootstrap');

// Safety guard: if the main app JS is accidentally loaded at an /admin/* URL
// (which happens when routes/web.php is missing the admin route), bail out early
// so the main Vue app does not mount on top of an admin page.
if (window.location.pathname.startsWith('/admin')) {
	const root = document.getElementById('app');
	if (root) {
		root.innerHTML = '<div style="padding:40px;font-family:sans-serif;text-align:center;color:#c00">'
			+ '<strong>Eroare de rutare:</strong> Panoul de administrare nu a putut fi încărcat. '
			+ 'Asigurați-vă că <code>routes/web.php</code> conține ruta <code>/admin/{any?}</code> '
			+ 'și că rulați aplicația de pe ramura corectă a proiectului.'
			+ '</div>';
	}
	throw new Error('[Main App] Mounted at /admin/* — routing misconfiguration. Admin route missing in routes/web.php.');
}

async function bootstrapApp() {
	const savedToken = window.localStorage.getItem('auth_token');

	if (savedToken) {
		window.axios.defaults.headers.common.Authorization = `Bearer ${savedToken}`;

		// Validate the stored token before mounting so that stale/expired tokens
		// are cleared before any component fires its first API request.
		// Only a definitive 401 clears the token; network/server errors leave it
		// intact so the app retries normally.
		try {
			await window.axios.get('auth/me');
		} catch (e) {
			if (e?.response?.status === 401) {
				window.localStorage.removeItem('auth_token');
				delete window.axios.defaults.headers.common.Authorization;
			}
		}
	}

	const application = createApp(App);
	application.use(router);
	application.config.globalProperties.$api = window.axios;

	const appRoot = document.getElementById('app');
	if (appRoot) {
		application.mount(appRoot);
	}
}

bootstrapApp();
